import * as React from "react";
import { HoverableImage } from "../../components/HoverableImage/HoverableImage";
import { talentOfTomorrowPhotos } from "../../constants/photos";
import styles from "./TalentOfTomorrow.module.css";

const TalentOfTomorrow = () => {
  const gallery = talentOfTomorrowPhotos.map((image) => (
    <HoverableImage
      src={image.src}
      infoTitle={image.infoTitle}
      infoDescription={image.infoDescription}
      isHalfImg={image.isHalfImg}
    />
  ));

  return (
    <>
      <h2 className={styles.title}>Fashion Accelerator Programe by GFW, PVH Corp, and DAZED</h2>
      <p className={styles.description}>
        One of eight brands selected for the Graduate Fashion Foundation’s Fashion Accelerator Programme. Fascinated by technical challenges, I chose to focus on the corset as one of fashion’s most complex garments to construct, perfect and adapt for modern-day wear. Founded during my placement year, the label became an ongoing experiment through which I applied knowledge gained from my studies and industry experience, explored bespoke and made-to-order production, identified the target customer, and tested different routes to market, including direct-to-customer sales, bespoke client orders, presentations and engagement with buyers.
      </p>
      <div className={styles.galleryContainer}>
        <div className={styles.desktopGalleryContainer}>{gallery}</div>
        <div className={styles.mobileGalleryContainer}>{gallery}</div>
      </div>
      <p className={styles.description}>
        Photography: Amelia Howes
      </p>
    </>
  );
};

export default TalentOfTomorrow;
